import './Footer.css';

export interface OntologyStats {
    classes: number;
    objectProperties: number;
    datatypeProperties: number;
    individuals: number;
    triples: number;
}

interface FooterProps {
    stats: OntologyStats;
}

const TECH_STACK = ['React', 'Fabric.js', 'Monaco', 'N3.js', 'Dagre'];
const VERSION = '0.1.0';
const BUILD_DATE = '2026-02-01';

function Footer({ stats }: FooterProps) {
    return (
        <footer className="footer">
            <div className="footer__stats">
                <div className="footer__stat">
                    <span>Classes:</span>
                    <span className="footer__stat-value">{stats.classes}</span>
                </div>
                <div className="footer__stat">
                    <span>ObjProps:</span>
                    <span className="footer__stat-value">{stats.objectProperties}</span>
                </div>
                <div className="footer__stat">
                    <span>DataProps:</span>
                    <span className="footer__stat-value">{stats.datatypeProperties}</span>
                </div>
                <div className="footer__stat">
                    <span>Individuals:</span>
                    <span className="footer__stat-value">{stats.individuals}</span>
                </div>
                <div className="footer__stat">
                    <span>Triples:</span>
                    <span className="footer__stat-value">{stats.triples}</span>
                </div>
            </div>

            <div className="footer__tech">
                <span className="footer__tech-label">POWERED BY:</span>
                {TECH_STACK.map((tech) => (
                    <span key={tech} className="footer__tech-item">{tech}</span>
                ))}
            </div>

            <div className="footer__version">
                v{VERSION} | {BUILD_DATE}
            </div>
        </footer>
    );
}

export default Footer;
